(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-media-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wrappers = document.querySelectorAll('.floating-media');
    const now = Date.now();

    const getStorageData = (wrapper) => {
      const sectionId = wrapper.dataset.sectionId;
      const behavior = wrapper.dataset.closeBehavior || 'none';
      const snoozeDays = Number(wrapper.dataset.snoozeDays || '7');
      const key = `floating-media-dismissed-${sectionId}`;
      return { behavior, snoozeDays, key };
    };

    const shouldHide = (wrapper) => {
      const { behavior, key } = getStorageData(wrapper);

      if (behavior === 'session') {
        return sessionStorage.getItem(key) === '1';
      }

      if (behavior === 'permanent') {
        return localStorage.getItem(key) === '1';
      }

      if (behavior === 'snooze') {
        const snoozeUntil = Number(localStorage.getItem(key) || '0');
        return snoozeUntil > now;
      }

      return false;
    };

    const persistDismiss = (wrapper) => {
      const { behavior, key, snoozeDays } = getStorageData(wrapper);

      if (behavior === 'session') {
        sessionStorage.setItem(key, '1');
        return;
      }

      if (behavior === 'permanent') {
        localStorage.setItem(key, '1');
        return;
      }

      if (behavior === 'snooze') {
        const snoozeMs = Math.max(snoozeDays, 1) * 24 * 60 * 60 * 1000;
        localStorage.setItem(key, String(Date.now() + snoozeMs));
      }
    };

    wrappers.forEach((wrapper) => {
      if (shouldHide(wrapper)) {
        wrapper.style.display = 'none';
        return;
      }

      const frame = wrapper.querySelector('.floating-media__frame');
      const closeButton = wrapper.querySelector('[data-floating-close]');
      const muteButton = wrapper.querySelector('[data-floating-mute]');
      const fullscreenButton = wrapper.querySelector('[data-floating-fullscreen]');
      const video = wrapper.querySelector('[data-floating-video]');
      const muteIcon = wrapper.querySelector('[data-icon-mute]');
      const unmuteIcon = wrapper.querySelector('[data-icon-unmute]');

      if (closeButton) {
        closeButton.addEventListener('click', () => {
          persistDismiss(wrapper);
          wrapper.style.display = 'none';
        });
      }

      if (video && muteButton) {
        const syncMuteState = () => {
          muteButton.classList.toggle('is-muted', video.muted);
          muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
          if (muteIcon) muteIcon.setAttribute('aria-hidden', video.muted ? 'false' : 'true');
          if (unmuteIcon) unmuteIcon.setAttribute('aria-hidden', video.muted ? 'true' : 'false');
        };

        syncMuteState();

        muteButton.addEventListener('click', () => {
          video.muted = !video.muted;
          syncMuteState();
        });
      }

      if (frame && fullscreenButton) {
        fullscreenButton.addEventListener('click', async () => {
          if (!document.fullscreenElement) {
            try {
              await frame.requestFullscreen();
            } catch (error) {}
            return;
          }
          try {
            await document.exitFullscreen();
          } catch (error) {}
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
